export const EXPERIMENTS = {
  TARGET_SETTING: 'specs.forms.ComposerTargetSetting',
  MOVE_ECOM_LABEL_TRANSLATIONS: 'specs.forms.MoveEcomLabelTranslations',
  ENABLE_DUPLICATE: 'specs.forms.EnableDuplicate',
  ENHANCE_ECOM_SETTINGS: 'specs.forms.EnhanceEcomSettings',
  ENABLE_SHORTCUTS: 'specs.forms.EnableShortcuts',
  DOUBLE_OPT_IN_SETTING: 'specs.forms.DoubleOptInSettings',
  TRANSLATE_ECOM_EMAIL: 'specs.forms.TranslateEcomEmail',
  DYNAMIC_SUBDIVISIONS: 'specs.forms.DynamicSubdivisions',
  PREFILL_PLACEHOLDER: 'specs.forms.PrefillPlaceholder',
  ENABLE_DEXT_PHONE_INPUT: 'specs.forms.EnableDextPhoneField',
  ENABLE_PHONE_FIELD: 'specs.forms.EnablePhoneField',
  ENABLE_ARCHIVE_FORMAT: 'specs.forms.FileUploadArchiveFormat',
  OVERRIDE_MLA_FIELD_IDS: 'specs.forms.OverrideMLAFieldIds'
};
//# sourceMappingURL=experiments.js.map